import React from 'react';
import actimg from '../../images/about.jpg';
import actshape from '../../images/shape/shape2.png';
import { Link } from 'react-router-dom';
import featuresimg from '../../images/features/img-1.png';

const Activities = () => {
    return (
        <>
        <div className="about-area section-padding">
            <div className="container">
                <div className="row align-items-center">

                    {/* Left Side - Text */}
                    <div className="col-lg-7 col-md-12 col-12">
                        <div className="about-text">
                            <div className="section-title">
                                <div className="thumb-text">
                                    <span>OUR ACTIVITIES</span>
                                </div>
                                <h2>Our Community & Outreach Programs</h2>
                            </div>

                            <p>
                                Our programs are designed for a wide spectrum of learners – school children, adolesecents, working women, homemakers and middle – aged women.
                            </p>

                            <p>
                                Each group is trained with age appropriate and body sensitive methodologies that strengthen the muscles, improve memory and concentration, enhance posture and support overall physical and emotional health.
                            </p>

                            <p>
                                Unlike traditional informal training our syllabus is research- driven and developed with the support of experts in performing arts, physiotheraphy, optometry, occupational theraphy and psychology. This analytical approach helps students understand how their body and mind function, enabling safer practice and long term development.
                            </p>
                        </div>
                    </div>

                    {/* Right Side - Image */}
                    <div className="col-lg-5 col-md-12 col-12">
                        <div className="image-area text-center">
                            <img
                                src={actimg}
                                alt="NGO Activities"
                                className="img-fluid rounded shadow"
                                style={{
                                    borderRadius: '12px',
                                    objectFit: 'cover',
                                    width: '100%'
                                }}
                            />
                        </div>
                    </div>

                </div>
            </div>

            {/* Decorative Shape */}
            <div className="ab-shape">
                <img src={actshape} alt="Decorative background shape" />
            </div>

        </div>
        </>
    );
};

export default Activities;
